import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  borderDiv: {
    "&:hover": {
      borderColor: (props: { bordercolor?: string; disabled?: boolean }) =>
        !props?.disabled ? props?.bordercolor : "#C4C4C4",
    },
    border: "1px solid #C4C4C4",
    width: "100%",
    borderRadius: "8px",
    display: "flex",
    alignItems: "center",
    padding: "0px 10px",
    height: "40px",
  },
  input: {
    "&  .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "transparent !important",
      },
      height: "auto !important",
    },
    "& .MuiOutlinedInput-input": {
      padding: "0px !important",
    },
    marginLeft: "10px",
  },
}));

export default styles;
